const CONTROL_SELECTOR: string = "[data-customer-control]";
const CONTROL_BUSINESS_SELECTOR: string = "[data-control-business]";
const CONTROL_NEXT_SELECTOR: string = "[data-control-next]";

export class controlUI {

  public constructor(private $base: HTMLElement) {
  }

  public onTabClick() {
    this.$base.querySelector(CONTROL_NEXT_SELECTOR).addEventListener('click', (e) => {

        if (this.$base.querySelector(CONTROL_BUSINESS_SELECTOR).classList.contains('customer-control-b2b')) {
          this.$base.querySelector(CONTROL_BUSINESS_SELECTOR).classList.remove('customer-control-b2b');
          this.$base.querySelector(CONTROL_BUSINESS_SELECTOR).classList.add('customer-control-b2c');

          this.$base.querySelector('#customer-b2b').classList.add('hide');
          this.$base.querySelector('#customer-b2c').classList.add('go');
          this.$base.querySelector('#customer-b2c').classList.remove('hide');
          this.$base.querySelector('#customer-b2b').classList.remove('go');

          this.$base.querySelector('#customer-control-b2c').classList.remove('is-out');

          window.setTimeout(() => {
            this.$base.querySelector('#rw-b2b').classList.add('go-in');
            this.$base.querySelector('#customer-control-b2b').classList.add('is-out');
          }, 600);

        } else {
          this.$base.querySelector(CONTROL_BUSINESS_SELECTOR).classList.remove('customer-control-b2c');
          this.$base.querySelector(CONTROL_BUSINESS_SELECTOR).classList.add('customer-control-b2b');

          this.$base.querySelector('#customer-b2c').classList.add('hide');
          this.$base.querySelector('#customer-b2b').classList.add('go');
          this.$base.querySelector('#customer-b2b').classList.remove('hide');
          this.$base.querySelector('#customer-b2c').classList.remove('go');

          this.$base.querySelector('#customer-control-b2b').classList.remove('is-out');

          window.setTimeout(() => {
            this.$base.querySelector('#rw-b2c').classList.add('go-in');
            this.$base.querySelector('#customer-control-b2c').classList.add('is-out');
          }, 600);
        }
    });
  }
}

export function createControlUI() {
  const $base = document.querySelectorAll(CONTROL_SELECTOR);
  let uiInstances: controlUI[] = [];

  for (let index = 0; index < $base.length; index++) {
    const element = $base[index] as HTMLElement;
    uiInstances.push(new controlUI(element));
  }
  return uiInstances;
}